import {_} from 'lodash';
import {moment} from 'moment';
import PromiseRequest from "../../../req/PromiseRequest";
import {global} from "../../../appContext";
import {ObjectTypeId} from "../../../constants";
import {createErrorMessage, getSyncFieldDisplayName, setCaretPosition} from "../../../util/misc";
import {Abstract} from "./Abstract";
import {getCancelButton, getSubmitButton, setRouteHash} from "../../../constants/RouteDefinitions";
import pubsub from "../../../pubsub";
import {nsDom} from "../../../util/dom";
import {NO_COMMENT, UPDATING_MESSAGE} from "../../../constants/Language";
import {nsCustomerGeneral} from "../general/fn";
import {ButtonManager} from "../../../util/ButtonManager";
import {IRouteDefinitionParams} from "../../../index";
import waitForElementId = nsDom.waitForElementId;
import urlEncodeCustomerKeys = nsCustomerGeneral.urlEncodeCustomerKeys;
import editHtml from './edit.html?raw';

export let template: string = editHtml;

export class viewModel extends Abstract {
    private NO_COMMENT = NO_COMMENT
    reqUpdate: PromiseRequest = new PromiseRequest('updatecompany');
    private pageButtons: ButtonManager = new ButtonManager()

    constructor(params: IRouteDefinitionParams) {
        super(params)

        this.pageButtons.add(getCancelButton())
        this.pageButtons.add(getSubmitButton({
            onClick: this.onSubmit.bind(this),
        }))
    }
    protected override initRequest(): Promise<void> {
        return super.initRequest()
            .then(() => {
                this.messageData(null);
                this.isReady(true);
                this.initEdit();
            })
    }

    private initEdit() {
        waitForElementId('edit-comments-textarea')
            .then((el: HTMLElement) => {
                const $el = el as HTMLTextAreaElement;
                if (!$el) {
                    this.initEdit();
                    return;
                }
                const user = global.login.user();
                if (!user) {
                    return;
                }
                const dateStr = moment().format('L')
                let content = this.comments();

                // if there is already content we'll add some line breaks before the new comment
                if (!!content) {
                    content = `\n\n${content}`;
                }

                const logStr = `${getSyncFieldDisplayName(ObjectTypeId.User, user.syncfields)}, ${dateStr}:\n`;
                this.comments(`${logStr}${content}`);
                const height = Math.max($el.scrollHeight, 150);
                $el.style.height = height + 'px';
                setCaretPosition($el, logStr.length);
            })
    }

    onSubmit() {
        this.isReady(false);
        this.messageData({message: UPDATING_MESSAGE});
        const data = _.cloneDeep(this.data);
        data.comment = this.comments();
        data.syncsteps = urlEncodeCustomerKeys(data.syncsteps)
        const json = JSON.stringify(data);
        this.reqUpdate
            .request({jcompany: json})
            .then(() => {
                global.cacheManager.removeCache('getcompany');
                global.snackbarData({message: `subject is updated|p|s:((comment|p))`});
                pubsub.trigger('company.comments.updated');
                setRouteHash('customercommentsdetails');
            })
            .catch(reason => this.messageData(createErrorMessage(String(reason))));
    }

    override dispose() {
        super.dispose();
        this.reqUpdate.abort();
    }
}
